<template>
	<ManagingSection :isTable="true" class="product-list">
		<template slot="infoSection">
			<div class="section__info__left">
				<p>
					등록 : {{ totalItem }}건 / 전시 : {{ isDisplayCnt }}건 /
					비전시 : {{ unIsDisplayCnt }}건
					<span class="product-list__desc">
						<span class="icon-discontinued">D</span> : 단종 제품
						(Discontinued)
					</span>
				</p>
			</div>
			<div class="section__info__right infoSection__button">
				<div class="infoSection__list">
					<label
						class="section__info__items product-list__toggle-sort"
					>
						<input
							v-model="readUpReviewDownModel"
							type="checkbox"
							class="product-list__toggle-sort-input"
						/>
						조회수 높고 리뷰 적은 제품
					</label>
					<SelectBox
						addClass="form-m section__info__items"
						@changing="
							$emit('change', [{ key: 'limit', value: $event }])
						"
						:options="limitList"
						:val="limit"
					/>
					<div class="infoSection__excel">
						<input
							type="file"
							id="file"
							@change="handleFileSelect"
							style="display: none"
						/>
						<label for="file" class="btn-excel section__info__items"
							>엑셀 업로드</label
						>
					</div>
					<button
						class="btn-excel download section__info__items"
						type="button"
						@click="openExcelModal"
						v-text="'엑셀 다운로드'"
					/>
				</div>
				<div class="infoSection__list">
					<button
						class="btn section__info__items"
						type="button"
						@click="openProductChangeModal('brand')"
						v-text="'브랜드 일괄 이동'"
					/>
					<button
						class="btn section__info__items"
						type="button"
						@click="openProductChangeModal('store')"
						v-text="'판매처 일괄 변경'"
					/>
					<button
						class="btn section__info__items"
						type="button"
						@click="changeDisplayStatus(true)"
						v-text="'일괄 전시'"
					/>
					<button
						class="btn section__info__items"
						type="button"
						@click="changeDisplayStatus(false)"
						v-text="'일괄 비전시'"
					/>
				</div>
			</div>
		</template>
		<table class="table-main product-list__table">
			<thead>
				<tr>
					<th class="product-list__check-cell">
						<input
							type="checkbox"
							v-model="allCheckModel"
							:value="allCheck"
						/>
					</th>
					<th class="product-list__id-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[1].value"
							:id="sortList[1].id"
							title="번호"
							:down="11"
							:up="12"
						/>
					</th>
					<th class="product-list__name-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[2].value"
							:id="sortList[2].id"
							title="제품명"
							:down="21"
							:up="22"
						/>
					</th>
					<th class="product-list__brand-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[3].value"
							:id="sortList[3].id"
							title="브랜드명"
							:down="31"
							:up="32"
						/>
					</th>
					<th class="product-list__price-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[4].value"
							:id="sortList[4].id"
							title="가격"
							:down="41"
							:up="42"
						/>
					</th>
					<th class="product-list__cate-cell" v-text="'카테고리'" />
					<th class="product-list__img-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[5].value"
							:id="sortList[5].id"
							title="사진"
							:down="51"
							:up="52"
						/>
					</th>
					<th class="product-list__count-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[6].value"
							:id="sortList[6].id"
							title="조회"
							:down="61"
							:up="62"
						/>
					</th>
					<th class="product-list__wish-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[7].value"
							:id="sortList[7].id"
							title="위시"
							:down="71"
							:up="72"
						/>
					</th>
					<th class="product-list__review-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[8].value"
							:id="sortList[8].id"
							title="리뷰"
							:down="91"
							:up="92"
						/>
					</th>
					<th class="product-list__avg-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[9].value"
							:id="sortList[9].id"
							title="평점"
							:down="101"
							:up="102"
						/>
					</th>
					<th class="product-list__popular-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[10].value"
							:id="sortList[10].id"
							title="인기"
							:down="111"
							:up="112"
						/>
					</th>
					<th class="product-list__ingredient-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[11].value"
							:id="sortList[11].id"
							title="성분"
							:down="121"
							:up="122"
						/>
					</th>
					<th class="product-list__date-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[12].value"
							:id="sortList[12].id"
							title="등록일"
							:down="131"
							:up="132"
						/>
					</th>
					<th class="product-list__date-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[13].value"
							:id="sortList[13].id"
							title="수정일"
							:down="141"
							:up="142"
						/>
					</th>
					<th class="product-list__date-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[14].value"
							:id="sortList[14].id"
							title="성분등록일"
							:down="161"
							:up="162"
						/>
					</th>
					<th class="product-list__date-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[15].value"
							:id="sortList[15].id"
							title="성분수정일"
							:down="171"
							:up="172"
						/>
					</th>
					<th class="product-list__display-cell">
						<SortLabel
							@change="changingSort"
							:propsValue="sortList[16].value"
							:id="sortList[16].id"
							title="전시"
							:down="151"
							:up="152"
						/>
					</th>
					<th class="product-list__duplicate-cell" v-text="'복제'" />
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="productItem in parsingProducts"
					:key="productItem.idProduct"
					:class="{
						'product-list__no-display-tr': !productItem.isDisplay,
					}"
				>
					<td class="product-list__check-cell">
						<input
							type="checkbox"
							v-model="listCheckListModel"
							:value="productItem.idProduct"
						/>
					</td>
					<td
						class="product-list__id-cell"
						v-text="productItem.idProduct"
					/>
					<td class="product-list__name-cell">
						<RouterLink
							:to="`/product/product-inquiry/${productItem.idProduct}`"
							class="link"
						>
							<span
								v-if="productItem.isDiscontinue"
								class="icon-discontinued"
								v-text="'D'"
							/>
							{{ productItem.productTitle }}
						</RouterLink>
					</td>
					<td
						class="product-list__brand-cell"
						v-text="productItem.brandTitle"
					/>
					<td
						class="product-list__price-cell"
						v-text="productItem.parsedPrice"
					/>
					<td
						class="product-list__cate-cell"
						v-text="productItem.fullPrimeCategory"
					/>
					<td
						:class="[
							'product-list__img-cell-data',
							{
								'product-list__img-cell-data--true':
									productItem.fileSaveNameYN,
							},
						]"
						v-text="productItem.parsedFileSaveNameYN"
					/>
					<td
						class="product-list__count-cell"
						v-text="productItem.parsedReadCount"
					/>
					<td
						class="product-list__wish-cell"
						v-text="productItem.parsedWishCount"
					/>
					<td
						class="product-list__review-cell"
						v-text="productItem.parsedCommentCount"
					/>
					<td
						class="product-list__avg-cell"
						v-text="productItem.ratingAvg"
					/>
					<td
						class="product-list__popular-cell"
						v-text="productItem.parsedProductScore"
					/>
					<td
						class="product-list__ingredient-cell"
						v-text="productItem.parsedFactorsCount"
					/>
					<td
						class="product-list__date-cell"
						v-text="productItem.parsedCreateDate"
					/>
					<td
						class="product-list__date-cell"
						v-html="`${productItem.parsedModifiedDate}`"
					/>
					<td
						class="product-list__date-cell"
						v-text="productItem.parsedFactorsInsertedDate"
					/>
					<td
						class="product-list__date-cell"
						v-text="productItem.parsedFactorsModifiedDate"
					/>
					<td class="product-list__display-cell">
						<p
							:class="[
								'product-list__display-cell-text',
								{
									'product-list__display-cell-text--true':
										productItem.isDisplay,
								},
							]"
							v-text="productItem.parsedIsDisplay"
						/>
						<select
							class="select product-list__display-select"
							@change="
								toggleDisplay(
									productItem.idProduct,
									!productItem.isDisplay,
									$event.target
								)
							"
							:value="productItem.isDisplay"
						>
							<option :value="false">N변경</option>
							<option :value="true">Y변경</option>
						</select>
					</td>
					<td class="product-list__duplicate-cell">
						<button
							@click="
								duplicate(
									productItem.productTitle,
									productItem.idProduct
								)
							"
							class="btn orange"
							v-text="'복제'"
						/>
					</td>
				</tr>
			</tbody>
		</table>
		<PaginationBox
			v-if="parsingProducts.length > 0"
			:totalItem="totalItem"
			:limit="limit"
			:offset="offset"
			:pageLengPerOne="10"
			@to="paging"
			slot="pagination"
		/>
	</ManagingSection>
</template>
<script>
	import _ from 'lodash';
	import moment from 'moment';
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import SortLabel from '@/components/product/SortLabel.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SelectBox from '@/components/SelectBox.vue';
	import util from '@/util.js';

	export default {
		name: 'ProductListTable',
		components: { ManagingSection, SortLabel, PaginationBox, SelectBox },
		props: {
			products: {
				type: Array,
				default() {
					return [];
				},
			},
			totalItem: { type: Number },
			isDisplayCnt: { type: Number },
			unIsDisplayCnt: { type: Number },
			offset: { type: Number },
			limit: { type: Number },
		},
		data() {
			return {
				allCheck: false,
				sortList: [
					{ id: 'readUpReviewDown', value: false },
					{ id: 'id', value: true },
					{ id: 'productTitle', value: null },
					{ id: 'brandTitle', value: null },
					{ id: 'price', value: null },
					{ id: 'file', value: null },
					{ id: 'read', value: null },
					{ id: 'wish', value: null },
					{ id: 'review', value: null },
					{ id: 'rating', value: null },
					{ id: 'score', value: null },
					{ id: 'factors', value: null },
					{ id: 'create', value: null },
					{ id: 'modified', value: null },
					{ id: 'factorCreate', value: null },
					{ id: 'factorModify', value: null },
					{ id: 'display', value: null },
				],
				limitList: [
					{ id: 10, text: '10개씩' },
					{ id: 20, text: '20개씩' },
					{ id: 30, text: '30개씩' },
					{ id: 40, text: '40개씩' },
					{ id: 50, text: '50개씩' },
				],
			};
		},
		computed: {
			...mapState('productList', ['productCheckList']),
			allCheckModel: {
				get() {
					return this.allCheck;
				},
				set(newVal) {
					const value = [];
					if (
						Array.isArray(this.parsingProducts) &&
						this.parsingProducts.length > 0 &&
						newVal === true
					) {
						this.parsingProducts.forEach(item => {
							value.push(item.idProduct);
						});
					}
					this.$store.commit('productList/changeState', [
						{
							key: 'productCheckList',
							value,
						},
					]);
					this.allCheck = newVal;
				},
			},
			readUpReviewDownModel: {
				get() {
					return this.sortList[0].value;
				},
				set(newValue) {
					const changes = [
						{
							newValue,
							id: this.sortList[0].id,
						},
					];
					if (newValue === true) {
						changes.push({
							newValue: false,
							id: 'read',
						});
						changes.push({
							newValue: true,
							id: 'review',
						});
					} else if (newValue === false) {
						changes.push({
							newValue: true,
							id: 'id',
						});
					}
					this.changingSort(changes);
				},
			},
			listCheckListModel: {
				get() {
					return this.productCheckList;
				},
				set(newList) {
					this.$store.commit('productList/changeState', [
						{
							key: 'productCheckList',
							value: newList,
						},
					]);
					if (this.parsingProducts.length === newList.length) {
						this.allCheck = true;
					} else if (this.parsingProducts.length > newList.length) {
						this.allCheck = false;
					}
				},
			},
			parsingProducts() {
				return _.cloneDeep(this.products).map(item => {
					const fullPrimeCategory = [];
					if (item.firstCategoryText) {
						fullPrimeCategory.push(item.firstCategoryText);
						if (item.secondCategoryText) {
							fullPrimeCategory.push(item.secondCategoryText);
							if (item.thirdCategoryText) {
								fullPrimeCategory.push(item.thirdCategoryText);
							}
						}
					}
					item.fullPrimeCategory = fullPrimeCategory.join(' > ');
					item.parsedIsDisplay = this.yOrN(item.isDisplay);
					item.parsedFileSaveNameYN = this.yOrN(item.fileSaveNameYN);
					item.parsedReadCount = this.parseCurrency(item.readCount);
					item.parsedWishCount = this.parseCurrency(item.wishCount);
					item.parsedCommentCount = this.parseCurrency(
						item.commentCount
					);
					item.parsedProductScore = this.parseCurrency(
						item.productScore,
						''
					);
					item.parsedCreateDate = this.dateStrParsing(
						item.createDate
					);
					item.parsedModifiedDate = this.dateStrParsing(
						item.modifiedDate
					);
					item.parsedPrice = this.parseCurrency(item.price, '-');
					item.parsedFactorsCount = this.parseCurrency(
						item.factorsCount,
						'-'
					);
					item.parsedFactorsModifiedDate = this.dateStrParsing(
						item.factorsModifiedDate
					);
					item.parsedFactorsInsertedDate = this.dateStrParsing(
						item.factorsInsertedDate
					);
					return item;
				});
			},
		},
		methods: {
			changingSort(changeList) {
				this.sortList = this.sortList.map(item => {
					let newVal = null;
					const isChanged = changeList.some(changes => {
						if (changes.id === item.id) {
							newVal = changes.newValue;
							return true;
						}
					});
					item.value = newVal;
					return item;
				});
			},
			dateStrParsing(dateStr) {
				return dateStr && dateStr !== '19801221232000'
					? moment(dateStr, 'YYYYMMDDHHmmss').format('YYYY-MM-DD')
					: '-';
			},
			paging({ offset }) {
				this.$emit('paging', offset);
			},
			openProductChangeModal(name) {
				if (this.productCheckList.length < 1) {
					alert('제품을 선택하세요');
					return;
				}

				if (name === 'store') {
					this.$store.commit('modal/toggleModal', {
						id: 'ProductStoreChange',
					});
				} else if (name === 'brand') {
					this.$store.commit('modal/toggleModal', {
						id: 'ProductBrandChange',
					});
				}
			},
			openExcelModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'ExcelDownList',
					params: { total: this.totalItem, type: 'productList' },
				});
			},
			async toggleDisplay(id, isDisplay, target) {
				try {
					const url = `/api/products/isDisplay/${id}?isDisplay=${isDisplay}`;
					const { data } = await this.$axiosAdmin2.put(url);
					if (data.msg) {
						alert(data.msg);
						target.value = String(!isDisplay);
						return;
					}
					const idProduct = data.data;
					this.$emit('changeListDisplay', idProduct);
					const msg = `${isDisplay ? '' : '비'}전시상태로 변경되었습니다`;
					alert(msg);
				} catch (err) {
					console.error(err);
					alert(
						'전시여부를 변경하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			initSort(order) {
				if (!order || Number(order) === 11) return;
				order = Number(order);
				if (order === 2) {
					this.changingSort([
						{ id: 'readUpReviewDown', newValue: true },
						{ id: 'read', newValue: false },
						{ id: 'review', newValue: true },
					]);
				} else if (order === 12) {
					this.changingSort([{ id: 'id', newValue: false }]);
				} else {
					let id;
					switch (order) {
						case 21:
						case 22:
							id = 'productTitle';
							break;
						case 31:
						case 32:
							id = 'brandTitle';
							break;
						case 41:
						case 42:
							id = 'price';
							break;
						case 51:
						case 52:
							id = 'file';
							break;
						case 61:
						case 62:
							id = 'read';
							break;
						case 71:
						case 72:
							id = 'wish';
							break;
						case 91:
						case 92:
							id = 'review';
							break;
						case 101:
						case 102:
							id = 'rating';
							break;
						case 111:
						case 112:
							id = 'score';
							break;
						case 121:
						case 122:
							id = 'factors';
							break;
						case 131:
						case 132:
							id = 'create';
							break;
						case 141:
						case 142:
							id = 'modified';
							break;
						case 161:
						case 162:
							id = 'factorCreate';
							break;
						case 171:
						case 172:
							id = 'factorModify';
							break;
						case 151:
						case 152:
							id = 'display';
							break;
					}
					this.changingSort([{ id, newValue: !util.isEven(order) }]);
				}
			},
			async duplicate(name, id) {
				try {
					if (!confirm(`제품 "${name}" 을 복제하시겠습니까?`)) return;
					const {
						data: { data: detail },
					} = await this.$axiosAdmin2.get(`/api/products/${id}`);

					const params = {
						brandTypeList: (detail.storeList || []).map(
							item => item.idBrandType
						),
						colorType: detail.colorType,
						factorList: detail.factorList.map(
							({
								factorIdx,
								orderIndex,
								factorKorean,
								factorEnglish,
							}) => ({
								factorIdx,
								orderIndex,
								factorName: `${factorKorean}(${factorEnglish})`,
							})
						),
						factorsDisplay: detail.factorsDisplay,
						fileDir: '',
						fileSaveName: '',
						fileSize: 0,
						fileType: '',
						fileOrgName: '',
						path: '',
						idBrand: detail.idBrand,
						insertIdRegister: this.$store.state.login.idRegister,
						isDiscontinue: detail.isDiscontinue,
						isDisplay: false,
						price: detail.price,
						productText: detail.productText,
						productTitle: detail.productTitle,
						volume: detail.volume,
						releaseYear: detail.releaseYear,
						releaseMonth: detail.releaseMonth,
						productTagList: (detail.productTagList || []).map(
							({ tag }) => tag
						),
					};

					params.categoryMappings = (detail.categoryList || []).map(
						item => {
							const category = { isPrimary: item.isPrimary };
							if (item.idFirstCategory)
								category.idFirstCategory = item.idFirstCategory;
							if (item.idSecondCategory)
								category.idSecondCategory =
									item.idSecondCategory;
							if (item.idThirdCategory)
								category.idThirdCategory = item.idThirdCategory;
							if (item.isPrimary) {
								category.isPrimary = item.isPrimary;
								params.primarySecondCategory =
									item.idSecondCategory;
							}
							return category;
						}
					);

					const { data } = await this.$axiosAdmin2.post(
						'/api/products',
						params
					);
					alert(data.msg || '복제 성공!');
					this.paging({ offset: 0 });
				} catch (err) {
					console.error(err);
					alert(
						`제품 "${name}" 복제 실패했습니다. 개발팀에 문의하세요.`
					);
				}
			},
			parseCurrency(val, defVal) {
				return defVal === undefined
					? util.currency((val || 0).toString())
					: val
						? util.currency(val.toString())
						: defVal;
			},
			yOrN(val) {
				return val ? 'Y' : 'N';
			},
			async changeDisplayStatus(status) {
				if (this.productCheckList.length < 1) {
					alert('제품을 선택하세요');
					return;
				}
				if (status) {
					if (!confirm('일괄 전시로 변경하시겠습니까?')) return;
				} else {
					if (!confirm('일괄 비전시로 변경하시겠습니까?')) return;
				}
				await this.$store.dispatch('productList/changeDisplay', status);
			},
			async handleFileSelect(event) {
				const file = event.target.files[0];

				if (file) {
					let formData = new FormData();
					formData.append('file', file);

					try {
						await this.$axiosAdmin2.post(
							'/api/products/create-upload',
							formData
						);
						alert('엑셀 업로드를 성공하였습니다.');
						window.location.reload();
					} catch (err) {
						console.error(err);
						if (err.response.status === 415) {
							alert('파일 형식이 올바르지 않습니다.');
						} else {
							const message =
								err.response.data.message ||
								'엑셀 업로드를 실패하였습니다.';
							alert(message);
						}
					}
				}
			},
		},
		watch: {
			sortList(newList) {
				const key = 'order';
				let orderValue;
				const changeList = list => {
					for (let i = 0; i < list.length; i++) {
						const id = list[i].id;
						const value = list[i].value;
						if (
							(id === 'readUpReviewDown' && value === true) ||
							(id !== 'readUpReviewDown' && value !== null)
						) {
							switch (id) {
								case 'readUpReviewDown':
									orderValue = 2;
									break;
								case 'id':
									orderValue = value ? 11 : 12;
									break;
								case 'productTitle':
									orderValue = value ? 21 : 22;
									break;
								case 'brandTitle':
									orderValue = value ? 31 : 32;
									break;
								case 'price':
									orderValue = value ? 41 : 42;
									break;
								case 'file':
									orderValue = value ? 51 : 52;
									break;
								case 'read':
									orderValue = value ? 61 : 62;
									break;
								case 'wish':
									orderValue = value ? 71 : 72;
									break;
								case 'review':
									orderValue = value ? 91 : 92;
									break;
								case 'rating':
									orderValue = value ? 101 : 102;
									break;
								case 'score':
									orderValue = value ? 111 : 112;
									break;
								case 'factors':
									orderValue = value ? 121 : 122;
									break;
								case 'create':
									orderValue = value ? 131 : 132;
									break;
								case 'modified':
									orderValue = value ? 141 : 142;
									break;
								case 'factorCreate':
									orderValue = value ? 161 : 162;
									break;
								case 'factorModify':
									orderValue = value ? 171 : 172;
									break;
								case 'display':
									orderValue = value ? 151 : 152;
									break;
							}
							return [
								{
									key,
									value: orderValue,
								},
							];
						}
					}
				};
				this.$emit('change', changeList(newList));
			},
		},
		created() {
			this.initSort(this.$route.query.order);
		},
	};
</script>
<style lang="scss" scoped>
	.product-list {
		.infoSection {
			&__button {
				flex-direction: column-reverse;
				gap: 20px;
				align-items: flex-end;
			}

			&__list {
				display: flex;
			}
			&__excel {
				cursor: pointer;
				label {
					cursor: pointer;
				}
			}
		}

		&__desc {
			display: block;
			margin: 4px 0 0 0;
			line-height: 18px;
		}

		&__toggle-sort {
			cursor: pointer;
			padding: 0 5px;
			vertical-align: middle;
			line-height: 30px;

			&:hover {
				background: #f4f7fa;
			}

			&:active {
				background: #f7f7f7;
			}
		}

		&__toggle-sort-input {
			cursor: pointer;
			vertical-align: middle;
			margin: 0 2px 0 0;
		}

		&__table {
			table-layout: fixed;

			th,
			td {
				white-space: nowrap;
				text-align: center;

				& > [type='checkbox'] {
					cursor: pointer;
				}
			}

			th {
				vertical-align: middle;
			}

			td {
				vertical-align: top;
			}

			.product-list__check-cell {
				width: 30px;
				padding-left: 0;
				padding-right: 0;
			}

			.product-list__id-cell {
				width: 60px;
				padding-left: 0;
				padding-right: 0;
			}

			.product-list__name-cell {
				.icon-discontinued {
					margin-right: 4px;
				}
			}

			td.product-list__name-cell {
				white-space: normal;
				word-break: break-all;
				word-wrap: break-word;
				text-align: left;
			}

			td.product-list__brand-cell {
				white-space: normal;
				word-break: break-all;
				word-wrap: break-word;
				text-align: left;
			}

			.product-list__price-cell {
				width: 78px;
				padding-left: 0;
				padding-right: 0;
			}

			td.product-list__cate-cell {
				white-space: normal;
				word-break: break-all;
				word-wrap: break-word;
				text-align: left;
			}

			.product-list__img-cell {
				width: 40px;
				padding-left: 0;
				padding-right: 0;
				font-weight: 700;
			}

			.product-list__img-cell-data {
				@extend .product-list__img-cell;
				color: $red;

				&--true {
					color: $font-blue;
				}
			}

			.product-list__count-cell,
			.product-list__wish-cell,
			.product-list__review-cell {
				width: 74px;
				padding-left: 0;
				padding-right: 0;
			}

			.product-list__avg-cell {
				width: 50px;
				padding-left: 0;
				padding-right: 0;
			}

			.product-list__popular-cell {
				width: 64px;
				padding-left: 0;
				padding-right: 0;
			}

			.product-list__ingredient-cell {
				width: 50px;
				padding-left: 0;
				padding-right: 0;
			}

			.product-list__date-cell {
				width: 90px;
				padding-left: 0;
				padding-right: 0;
			}

			.product-list__display-cell {
				width: 80px;
				padding-left: 0;
				padding-right: 0;
			}

			.product-list__display-cell-text {
				color: $red;
				font-weight: 700;

				&--true {
					color: $font-blue;
				}
			}

			.product-list__duplicate-cell {
				width: 70px;
				padding-left: 0;
				padding-right: 0;
			}

			.product-list__display-select {
				margin: 4px auto 0 auto;
			}
		}

		&__no-display-tr {
			background: lightgray;
		}
	}
</style>
